import { keyframes } from 'styled-components';

type Keyframes = ReturnType<typeof keyframes>;

export const fadeIn: Keyframes = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
export const fadeOut: Keyframes = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
